import { render, staticRenderFns } from "./CompaignCard.vue?vue&type=template&id=c83af6e2&scoped=true&"
import script from "./CompaignCard.vue?vue&type=script&lang=js&"
export * from "./CompaignCard.vue?vue&type=script&lang=js&"
import style0 from "./CompaignCard.vue?vue&type=style&index=0&id=c83af6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83af6e2",
  null
  
)

export default component.exports